import React,{ useEffect,useState  } from 'react';
import Axios from 'axios'
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { styled } from '@mui/system';
import MdPhone from '@mui/icons-material/Phone';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import Menu from '@mui/material/Menu';
import { Link } from 'react-router-dom';
import { orange } from '@mui/material/colors';
import Chip from '@mui/material/Chip';


const DashboardNavbarRoot = styled(AppBar)({
  boxShadow: 3,
  backgroundColor: orange[500],
});
export default function DashboardNavbar(props) {
  const [isLogged, setisLogged] = useState(false);
  const [EmployeeType, setEmployeeType] = useState("");
  const [result, setResult] = useState("");
  const name = localStorage.getItem('name');
  const lastname = localStorage.getItem('lastname');
  useEffect(() => {
      const token = localStorage.getItem('token')
      fetch('http://27.254.66.164:5000/Author',{
      method: 'POST',
      withCredentials: true,
      mode: 'cors',
      headers: {
          'Authorization': 'Bearer '+token,
          'Content-Type': 'application/json',
      },
  })
  .then(response => response.json())
  .then(data => {
          if (data.status === 'ok'){
            setisLogged(true);
          } else {
            setisLogged(false);
          }
      });
  }, [isLogged])
  useEffect(()=>{
    Axios.post('http://27.254.66.164:5000/publish', {
      name: name,
      lastname: lastname
    }).then((response) => {
      setResult(response.data);
    });
  })
  useEffect(() => {
    const EmployeeType = JSON.parse(localStorage.getItem('EmployeeType'));
    if (EmployeeType) {
      setEmployeeType(EmployeeType);
     }
  },[setEmployeeType]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleLogout = (event) => {
    event.preventDefault();
    localStorage.removeItem('token');
    window.location = '/ec-crm/Login'
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <AccountCircleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{result}</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleLogout} >
          <ListItemIcon>
            <ExitToAppRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>ลงชื่อออก</ListItemText>
      </MenuItem>
    </Menu>
  );

  return (
    <>

      <DashboardNavbarRoot>
        <Toolbar>
          <IconButton  sx={{
            backgroundColor: '#ffffff',
            borderRadius: 20,
            width: "70" ,
            height: "40",
            '&:hover': {
              backgroundColor: '#576F72',
              boxShadow: 'none',
            },
            '&:active': {
              boxShadow: 'none',
              backgroundColor: '#ffffff',
            },
            
          }} 
            component={Link} to="/">
            <img src = {require('./../img/logo.png')} width="70" height="40"  alt="logo" /> 
          </IconButton>
          <Box sx={{ flexGrow: 5 }} />
          <Chip  sx={{
                backgroundColor: '#ffffff',
                borderRadius: 20,
                underline: "none",
                '--Link-gap': '0.5rem', pr: 0, pl: 1,
                width: "80" ,
                height: "50",
                '&:hover': {
                  backgroundColor: '#576F72',
                  boxShadow: 'none',
                },
                '&:active': {
                  boxShadow: 'none',
                  backgroundColor: '#ffffff',
                },
                
              }} variant="outlined" 
              component={Link} to="/Customer" icon={<MdPhone />} label="เพิ่มข้อมูลลูกค้า" />
          <Box sx={{ flexGrow: 0.1 }} />
              
               <Chip  sx={{
                backgroundColor: '#ffffff',
                borderRadius: 20,
                underline: "none",
                '--Link-gap': '0.5rem', pr: 0, pl: 1,
                width: "80" ,
                height: "50",
                '&:hover': {
                  backgroundColor: '#576F72',
                  boxShadow: 'none',
                },
                '&:active': {
                  boxShadow: 'none',
                  backgroundColor: '#ffffff',
                },
                
              }} variant="outlined" 
              component={Link} to="/ListCustomer" icon={<ListAltIcon />} label="ข้อมูลลูกค้า" />
              <Box sx={{ flexGrow: 0.1 }} />
              {(EmployeeType === 4 || EmployeeType === 5 ||EmployeeType === 6 ) ? (
                <Chip  sx={{
                backgroundColor: '#ffffff',
                borderRadius: 20,
                underline: "none",
                '--Link-gap': '0.5rem', pr: 0, pl: 1,
                width: "80" ,
                height: "50",
                '&:hover': {
                  backgroundColor: '#576F72',
                  boxShadow: 'none',
                },
                '&:active': {
                  boxShadow: 'none',
                  backgroundColor: '#ffffff',
                },
                
              }} variant="outlined" 
              component={Link} to="/ReportCus" icon={<DashboardIcon />} label="รายงานแบบสอบถาม" />
              ) : (<Box sx={{ flexGrow: 0.1 }} />)}
              <Box sx={{ flexGrow: 0.1 }} />
            <Box clone>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-haspopup="true"
                sx={{
                  backgroundColor: '#ffffff'
                }}
                onClick={handleProfileMenuOpen}
              >
                <AccountCircleIcon/>
              </IconButton>
            </Box>
        </Toolbar>
        {renderMenu}
      </DashboardNavbarRoot>
    </>
  );
};

